import { render } from "./productItems.vue?vue&type=template&id=2633cf56&scoped=true"
import script from "./productItems.vue?vue&type=script&lang=js"
export * from "./productItems.vue?vue&type=script&lang=js"

import "./productItems.vue?vue&type=style&index=0&id=2633cf56&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2633cf56"]])

export default __exports__